import { api, unwrap, type APIResponse, type Paginated } from "./client";

// Mirrors app/routers/trunk.py TrunkOut.
export interface Trunk {
  trunk_id: number;
  name: string;
  gateway_flag: number;
  service_flag: number;
  dialstring: string | null;
  channel_tech: string;
  endpoint_name: string | null;
  channel: number;
  cps: number;
  weight: number;
  is_active: boolean;
}

export interface TrunkListParams {
  page?: number;
  per_page?: number;
  active_only?: boolean;
}

export async function listTrunks(params: TrunkListParams): Promise<Paginated<Trunk>> {
  const resp = await api.get<Paginated<Trunk>>("/trunks/", { params });
  if (!resp.data.success) throw new Error(resp.data.error || "Failed to load trunks");
  return resp.data;
}

// Routing/capacity metadata only — physical PJSIP transport is seeded in Asterisk.
export interface TrunkInput {
  name: string;
  channel_tech: string;
  endpoint_name?: string | null;
  dialstring?: string | null;
  service_flag: number;
  gateway_flag: number;
  channel: number;
  cps: number;
  weight: number;
  is_active: boolean;
}

export async function createTrunk(body: TrunkInput): Promise<number> {
  const resp = await api.post<APIResponse<{ trunk_id: number }>>("/trunks/", body);
  return unwrap(resp.data).trunk_id;
}

export async function updateTrunk(id: number, body: TrunkInput): Promise<void> {
  await api.put(`/trunks/${id}`, body);
}

export async function deleteTrunk(id: number): Promise<void> {
  await api.delete(`/trunks/${id}`);
}
